import { Text } from '@change/ds-core-ui';
import { ScribblingPenIcon } from '@change/ds-icons';

import { SignersText } from '../SignersText';

export const Signers: React.FC<{
	constituentCount: number;
	isFormer: boolean;
	constituentCountLocalized: string;
}> = ({ constituentCount, isFormer, constituentCountLocalized }) => {
	return (
		<div className="flex items-center" data-testid="signers-text">
			<ScribblingPenIcon size={18} className="mr-1 text-icon-weak" />
			<Text as="div" size="small" className="text-muted">
				<SignersText
					constituentCount={constituentCount}
					constituentCountLocalized={constituentCountLocalized}
					isFormer={isFormer}
				/>
			</Text>
		</div>
	);
};
